import { Button } from '@components';

import {
  BannerData,
  BannerResolvedStyles,
  ProcessedComponentInstance
} from '../../types';

type BannerInstance = ProcessedComponentInstance<
  BannerData,
  BannerResolvedStyles
>;

interface CarouselDotsProps {
  banners: BannerInstance[];
  currentIndex: number;
  goTo: (index: number) => void;
}

const CarouselDots = ({ banners, currentIndex, goTo }: CarouselDotsProps) => {
  const activePillColor = banners[currentIndex]?.resolvedStyles.buttonBgColor;

  return (
    <div className="absolute inset-x-0 bottom-1 flex items-center justify-center gap-1.5">
      {banners.map((banner, idx) => (
        <div
          key={banner.id}
          style={
            idx === currentIndex
              ? ({
                  '--dot-bg': activePillColor
                } as React.CSSProperties)
              : undefined
          }
        >
          <Button
            variant="transparent"
            size="none"
            handleClick={() => goTo(idx)}
            className={`!h-1.5 !min-w-0 !rounded-full !p-0 transition-all duration-300 ${
              idx === currentIndex
                ? 'w-5 !bg-[var(--dot-bg)]'
                : 'w-1.5 !bg-cofeeGreyBlue6 opacity-60'
            }`}
            aria-label={`Go to banner ${idx + 1}`}
          />
        </div>
      ))}
    </div>
  );
};

export default CarouselDots;
